import { Optional } from '../model/types';
import BaseClient from './BaseClient';
import type { ResponseData } from './BaseClient.type';
import type {
  SearchUserRequestDto,
  UserLoginRequest,
  SearchUserResponseDto,
  RegisteMyUserRequestDto,
  UserRulesRequest,
  UserAdminInfo,
  ResetPwdRequest,
  UpdateUserRequest,
} from './UserClient.type';

class _UserClient extends BaseClient {
  public login(
    data: UserLoginRequest,
    uuid: string
  ): Promise<ResponseData<string>> {
    return this.postj<ResponseData<string>>('/user/login', data, {
      headers: {
        'V-Uuid': uuid,
      },
    });
  }

  public captcha(uuid: string) {
    return this.getj(
      '/user/captcha',
      {},
      {
        headers: {
          'V-Uuid': uuid,
        },
      }
    );
  }

  public info(): Promise<ResponseData<UserAdminInfo>> {
    return this.getj('/user/info');
  }
  // java
  public search(
    data: SearchUserRequestDto
  ): Promise<ResponseData<SearchUserResponseDto>> {
    return this.getj('/user/search', data);
  }

  public registe(
    data: RegisteMyUserRequestDto
  ): Promise<ResponseData<boolean>> {
    return this.postj('/user/registe', data);
  }

  public mapRules(data: UserRulesRequest): Promise<ResponseData<boolean>> {
    return this.postj('/user/map-rules', data);
  }

  public resetPwd(
    data: Optional<ResetPwdRequest, 'dupPwd'>
  ): Promise<ResponseData<boolean>> {
    return this.postj('/user/reset-pwd', data);
  }

  public update(data: UpdateUserRequest): Promise<ResponseData<boolean>> {
    return this.postj('/user/update', data);
  }

  public getDomainCfg(
    domain: string
  ): Promise<ResponseData<Record<string, string>>> {
    return this.getj('/tenant/domain', { domain });
  }
}

export const UserClient = new _UserClient();
